import { useContext, useEffect, useState } from "react"
import AOS from 'aos';
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneGallery from "./OneGallery";


export default function GalleryBanner(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllGallery(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  

  if (ready) {
    return (
      <div 
        className="MainBodySection bg-background text-primary"
        style={{
          paddingTop: "80px",
          paddingBottom: "80px",
          background: "linear-gradient(180deg, rgba(241,245,249,1) 0%, rgba(255,255,255,1) 100%)"
        }}
      >
        
        <div className="container">
          
          <div className="row">
            <div className="col-md-12 mb-5 text-center" data-aos="fade-up">
              <span 
                className="section-subtitle font-semi-bold mb-3 text-primary fs-3 text-uppercase"
                style={{ 
                  letterSpacing: "2.5px", 
                  fontSize: "0.85rem",
                  color: "#3b82f6",
                  fontWeight: "700"
                }}
              >
                Visual Portfolio
              </span>
              <h2 
                className="section-title font-bold"
                style={{ 
                  maxWidth: "850px", 
                  margin: "0 auto 1rem", 
                  fontWeight: "800",
                  fontSize: "2.25rem",
                  lineHeight: "1.3",
                  color: "#0f172a"
                }}
              >
                Capturing Moments of Strategic Impact
              </h2>
              <p 
                className="text-muted"
                style={{ 
                  maxWidth: "650px", 
                  margin: "0 auto", 
                  fontSize: "1.1rem",
                  lineHeight: "1.7",
                  color: "#475569"
                }}
              >
                Browse through our curated collection of client engagements, workshops, and milestone moments 
                that showcase our collaborative approach to business transformation.
              </p>
            </div>

            
            {
              (() => {
                const isHomePage = appContext.navItem === "" || appContext.navItem === "home";
                const displayedGallery = isHomePage ? (appContext.allGallery || []).slice(0, 3) : (appContext.allGallery || []);
                
                if (displayedGallery.length > 0) {
                  return displayedGallery.map((item, i) => (
                    <div 
                      key={i} 
                      className="col-md-4"
                      data-aos="fade-up" 
                      data-aos-delay={i * 150}
                    >
                      <OneGallery data={item}/>
                    </div>
                  ));
                }
                return (
                  <div className="col-md-12 mb-1 mt-1 text-muted text-center" data-aos="fade-up">
                    <h6 style={{ fontWeight: "500", fontSize: "1.1rem" }}>No media available at this time</h6>
                    <p className="text-secondary small mt-2">Our team is curating new visuals. Check back soon for fresh insights.</p>
                  </div>
                );
              })()
            }

            {/* View More Button for Home */}
            {
              (appContext.navItem === "" || appContext.navItem === "home") && (appContext.allGallery || []).length > 3 && (
                <div className="col-md-12 mt-5 text-center" data-aos="fade-up" data-aos-delay="450">
                  <a 
                    onClick={() => appContext.navTo({item: 'gallery'})} 
                    className="btn btn-primary px-5 py-3 text-uppercase fw-semibold"
                    style={{ 
                      borderRadius: "8px", 
                      letterSpacing: "1px",
                      fontSize: "0.9rem",
                      boxShadow: "0 4px 14px rgba(59, 130, 246, 0.35)",
                      transition: "all 0.3s ease",
                      border: "none",
                      background: "linear-gradient(135deg, #3b82f6, #2563eb)"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 8px 25px rgba(59, 130, 246, 0.5)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 14px rgba(59, 130, 246, 0.35)";
                    }}
                  >
                    Explore Full Gallery <span className="ms-2">→</span>
                  </a>
                </div>
              )
            }

          </div>

        </div>
        
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading" style={{ paddingTop: "60px", paddingBottom: "60px" }}>
        {getInlineLoader()}
      </div>
    );
  }
}